<template>
  <div>
    <div class="page-title">Edit School</div>
    <Form v-if="form" btnText="Update School" :submit="update" v-model="form" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.school.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setSchool();
  },
  methods: {
    async update() {
      await this.$api.School.update(this.form);
      this.$router.push("/schools");
    },
    async setSchool() {
      const { data } = await this.$api.School.get({
        id: this.$route.params.id,
      });
      this.form = data;
    },
  },
};
</script>

<style></style>
